import { FC, useRef } from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';

import strings from '../language/Swedish';
import { formatDateToString } from '../helpers';

const StyledDateInput = styled.div`
  ${tw`flex flex-col gap-2`};
`;

const Container = styled.div`
  ${tw`flex gap-1 items-center relative`};
`;

const Label = styled.label`
  ${tw`text-slate-500 text-xs w-14`};
`;

const Input = styled.input`
  ${tw`w-full bg-transparent border border-slate-400 rounded px-2.5 py-1.5 text-xs leading-none shadow-slate-300 text-slate-500 outline-none`};
  cursor: pointer;
  user-select: none;
  &:focus {
    ${tw`shadow-[0_0_0_4px_rgb(var(--color-primary)_/_0.2)] border-primary`};
  }
`;

interface Props {
  id: string;
  minId: string;
  maxId: string;
  value: [Date, Date];
  handleValueChange: (label: string, value: Date) => void;
}

const InputDateRange: FC<Props> = ({
  value,
  minId,
  maxId,
  handleValueChange,
}) => {
  const startInput = useRef(null);
  const endInput = useRef(null);

    const handleClick = (inputRef: React.RefObject<HTMLInputElement>) => {
    if (inputRef.current) {
      inputRef.current.showPicker();
    }
  };
  return (
    <StyledDateInput>
      <Container>
        <Label htmlFor="startId">{strings.filter.from}</Label>
        <Input
          id="startId"
          ref={startInput}
          type="date"
          min="1900-01-01"
          max="9999-12-31"
          value={formatDateToString(value[0]) || ''}
          onChange={(e) => {
            handleValueChange(minId, new Date(e.target.value));
          }}
          onClick={() => handleClick(startInput)}
        />
      </Container>
      <Container>
        <Label htmlFor="endId">{strings.filter.to}</Label>
        <Input
          id="endId"
          ref={endInput}
          type="date"
          min="1900-01-01"
          max="9999-12-31"
          value={formatDateToString(value[1]) || ''}
          onChange={(e) => {
            handleValueChange(maxId, new Date(e.target.value));
          }}
          onClick={() => handleClick(endInput)}
        />
      </Container>
    </StyledDateInput>
  );
}

export default InputDateRange;
